import { render, staticRenderFns } from "./EditGroupDialog.vue?vue&type=template&id=0b209037&scoped=true"
import script from "./EditGroupDialog.vue?vue&type=script&lang=ts"
export * from "./EditGroupDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b209037",
  null
  
)

export default component.exports